<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template #activator="{on}">
      <v-btn
        color="success"
        class="ml-2"
        :loading="loading"
        v-on="on"
      >
        Salvar
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        {{ payload.title }} mensagens?
      </v-card-title>
      <v-card-text>
        <span>Após confirmar, {{ payload.text }} </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="#6A6E7B"
          outlined
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          class="ml-2"
          @click="save()"
        >
          {{ payload.title }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NotificationSentModal',
  data: () => ({
    dialog: false,
    scheduleConfig: {
      title: 'Agendar',
      text: 'as alterações deverão ser feitas antes da data e hora de envio',
    },
    sentConfig: {
      title: 'Enviar',
      text: 'não será possível reverter o envio!',
    },
  }),
  computed: {
    save() {
      return () => {
        this.close();
        this.submitForm();
      };
    },
    loading() {
      return this.notification.loading;
    },
    status() {
      return this.notification.status;
    },
    isSent() {
      return this.status === 'Sent';
    },
    payload() {
      if (this.isSent) {
        return this.sentConfig;
      }
      return this.scheduleConfig;
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
  inject: {
    submitForm: {
      default() {
        return () => {};
      },
    },
    notification: {
      default() {
        return {
          loading: '',
          status: '',
        };
      },
    },
  },
};
</script>
